import clsx from "clsx";
import { FC, useState } from "react";
import { Fiat, Icons } from "rujira.ui";
import { CdpSingle } from "./utils";

const CRITICAL = 10n ** 12n;
const HIGH = 8n * 10n ** 11n;
const MEDIUM = 4n * 10n ** 11n;

export const LtvLabel: FC<{ ltv: bigint }> = ({ ltv }) => {
  if (ltv > CRITICAL)
    return (
      <div className="tag tag--borderless tag--red">
        Liquidatable:
        <span className="color-white ml-0.5">
          {(Number(ltv) / 1e10).toLocaleDecimal(2)}%
        </span>
      </div>
    );

  if (ltv > HIGH)
    return (
      <div className="tag tag--borderless tag--red">
        <span className="opacity-12 mr-0.5">High:</span>
        {(Number(ltv) / 1e10).toLocaleDecimal(2)}%
      </div>
    );

  if (ltv > MEDIUM)
    return (
      <div className="tag tag--borderless tag--orange">
        <span className="opacity-12 mr-0.5">Medium:</span>
        {(Number(ltv) / 1e10).toLocaleDecimal(2)}%
      </div>
    );

  return (
    <div className="tag tag--borderless tag--teal">
      <span className="opacity-12 mr-0.5">Low:</span>
      {(Number(ltv) / 1e10).toLocaleDecimal(2)}%
    </div>
  );
};

export const LiquidationPrice: FC<{
  p: CdpSingle<{ metadata: { symbol: string } }>;
}> = ({ p }) => {
  const { liquidationPrice, liquidationPriceDelta, ltv } = p;

  const abs =
    liquidationPriceDelta < 0n ? -liquidationPriceDelta : liquidationPriceDelta;

  const isShort = ["USDC", "USDT"].includes(p.collateral.asset.metadata.symbol);
  const [invert, setInvert] = useState(false);

  const SwitchArrow = () => (
    <button
      className="transparent iflex color-grey hover-white ml-1 pointer"
      onClick={() => {
        setInvert(!invert);
      }}>
      <Icons.ArrowRightLeft className="w-2 h-2 block" />
    </button>
  );

  return isShort || invert ? (
    <div className="iflex ai-c">
      <Fiat
        amount={
          liquidationPrice ? 10n ** 24n / liquidationPrice : liquidationPrice
        }
        symbol="$"
        decimals={12}
      />
      <div
        className={clsx({
          "tag tag--md ml-1": true,
          "tag--teal": ltv < MEDIUM,
          "tag--orange": MEDIUM <= ltv && ltv < HIGH,
          "tag--red": ltv >= HIGH,
        })}>
        <span>+{(Number(abs) / 1e10).toLocaleDecimal(2)}%</span>
        <Icons.TrendUp />
      </div>
      <SwitchArrow />
    </div>
  ) : (
    <div className="iflex ai-c">
      <Fiat amount={liquidationPrice} symbol="$" decimals={12} />
      <div
        className={clsx({
          "tag tag--md ml-1": true,
          "tag--teal": ltv < MEDIUM,
          "tag--orange": MEDIUM <= ltv && ltv < HIGH,
          "tag--red": ltv >= HIGH,
        })}>
        <span>-{(Number(abs) / 1e10).toLocaleDecimal(2)}%</span>
        <Icons.TrendDown />
      </div>
      <SwitchArrow />
    </div>
  );
};
